<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-lg-12 col-md-12 col-xl-9">
                <v-date-picker
                    mode='single'
                    class="custom-calendar w-100 border-0" 
                    title-position="left"
                    v-model='selectedDate'
                    :is-inline="true"
                    :show-day-popover="false"
                    :is-expanded='true'
                    @update:from-page="pageChange"
                >
                    <!-- @input="inputValue" @dayclick="dayClicked" -->
                    <template slot="day-content" slot-scope="props">
                        <b-link :disables="`${permitClick}`" class="text-dark" @click="dataInDay(props.day.id,'cilckInday')">
                            <div
                                class="flex flex-col h-full z-10 height-set" 
                                :class="{ 
                                    'bg-info-custom' : props.day.id === moment().format('YYYY-MM-DD'), 
                                    'card-CALEN' : !permitClick,
                                    'bg-actt' : activeId === props.day.id
                                }
                            ">
                                <span class="font-weight-bold ml-2 h5 day-label text-sm text-gray-900">
                                    <!-- <i v-if="activeId === props.day.id" class="fa fa-eye mr-2" aria-hidden="true"></i> -->
                                    {{ props.day.day }}
                                    <span class="text-right text-dark mr-1" v-if="props.day.id === moment().format('YYYY-MM-DD')">
                                        : Today
                                    </span>
                                </span>
                                <p></p>
                                <!-- leave off absent -->
                                <div 
                                    class="mt-1"
                                    v-for="(item, indexLL) in attributesLeave" :key="'eventLL'+ indexLL"
                                >
                                    <span v-if="moment(props.day.id).format('YYYY-MM-DD') >= moment(item.dates.start).format('YYYY-MM-DD') && moment(props.day.id).format('YYYY-MM-DD') <= moment(item.dates.end).format('YYYY-MM-DD')">
                                        <p 
                                            class="text-xs leading-tight rounded-sm mb-1" 
                                            :class="item.customData.class"
                                        ><i class="fa fa-user-times" aria-hidden="true"></i>({{ item.customData.status }}) {{ item.customData.type }}</p>
                                    </span>
                                </div>
                                <!-- Holiday & event -->
                                <div v-for="(item, indexL) in attributes" :key="'eventL'+ indexL" class="flex-grow overflow-y-auto overflow-x-auto">
                                    <!-- {{ item.dates.start }} -->
                                    <span v-if="moment(props.day.id).format('YYYY-MM-DD') >= moment(item.dates.start).format('YYYY-MM-DD') && moment(props.day.id).format('YYYY-MM-DD') <= moment(item.dates.end).format('YYYY-MM-DD')">
                                        <p 
                                            class="text-xs leading-tight rounded-sm mb-1" 
                                            :class="{ 
                                                'bg-danger text-white width-set font-sm text-truncate' : item.calendar_type === 'holiday',
                                                'bg-info text-white width-set font-sm-en text-truncate' : item.calendar_type === 'payday',
                                                'bg-warning text-dark width-set font-sm text-truncate' : item.calendar_type === 'announce',
                                                'bg-pur text-dark width-set font-sm text-truncate' : item.calendar_type === 'event',
                                            }"
                                            
                                        >
                                            <i
                                                :class="{ 
                                                    'fa fa-usd' : item.calendar_type === 'payday',
                                                    'fa fa-bullhorn' : item.calendar_type === 'announce',
                                                    'fa fa-bell' : item.calendar_type === 'event'
                                                }"
                                            >
                                            </i>
                                            {{ item.customData.title }}
                                            <span v-if="item.calendar_type === 'payday'">
                                                <br>
                                                <u>
                                                    <b-link
                                                        href="https://e-payroll.mahidol.ac.th/epayroll/" 
                                                        target="_blang"  
                                                        class="ml-2 text-white font-en"
                                                    >e-payroll.mahidol.ac.th<i class="fa fa-external-link" aria-hidden="true"></i></b-link>
                                                </u>
                                                <br>
                                            </span>
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </b-link>
                    </template>
                </v-date-picker>
            </div>
            <div class="col-sm-12 col-lg-12 col-md-12 col-xl-3 mb-5">
                <div v-if="this.$store.state.permit.RulesUser.roles.includes('staff')">
                    <h5 class="mt-2 mb-1 text-capitalize">
                        <strong>Time Attandance in</strong>
                    </h5>
                    <p class="mt-0 mb-2 text-capitalize font-weight-bold text-dark">{{ moment(DayInfomation).format("MMM Do YY") }}</p>
                    <hr>
                    <b-card style="border:1px solid #dadada;" class="mb-5">
                        <!--  
                            xxxxxx
                            <pre>{{ itemInday[0] }}</pre>
                            <pre>{{ itemInday[1] }}</pre>
                        -->
                        <div v-if="itemInday.length != 0">
                            <div class="mb-1 d-flex w-100 justify-content-between">
                                <p class="mb-0 text-success font-th font-weight-bold"><i class="fa fa-clock-o mr-1" aria-hidden="true"></i>เวลาเข้า :</p>
                                <p class="mb-0 font-weight-bold">{{ itemInday[itemInday.length - 1].c1 }}</p>
                            </div>
                            <hr>
                            <div class="mb-1 d-flex w-100 justify-content-between">
                                <p class="mb-0 text-danger font-th font-weight-bold"><i class="fa fa-clock-o mr-1" aria-hidden="true"></i>เวลาออก :</p>
                                <p v-if="timeCheckshow(itemInday,itemInday[0].c1)" class="mb-0 font-weight-bold">{{ itemInday[0].c1 }}</p>
                                <p v-else class="mb-0 font-weight-bold">-</p>
                            </div>
                            <!-- 
                                <pre>{{ itemInday[0].c1 }}</pre>
                                <pre>{{ timeCheckshow(itemInday,itemInday[itemInday.length - 1].c1) }}</pre>
                                <pre>{{ itemInday[itemInday.length - 1].c1 }}</pre> 
                            -->
                            <!-- 
                                <span 
                                    v-for="(item, indexTimeAtt) in itemInday" :key="'eventTimatt'+ indexTimeAtt"
                                    class="flex-column align-items-start"
                                >
                                    <div class="d-flex w-100 justify-content-between">
                                        <p 
                                            :class="{ 'text-success' : indexTimeAtt == 0 , 'text-danger' : indexTimeAtt == (itemInday.length - 1) && timeCheckshow(itemInday,item.c1) }"
                                            class="mb-1 font-en font-weight-bold"
                                        ><i class="fa fa-clock-o mr-1" aria-hidden="true"></i>Time stamp</p>
                                        <p class="mb-1 font-th">{{ item.c1 }}</p>
                                    </div>
                                    <hr v-if="indexTimeAtt < (itemInday.length - 1)">
                                </span> 
                            -->
                        </div>
                        <div v-else>
                            <h6 class="text-capitalize font-en text-muted">Still can't find Time stamp</h6>
                        </div>
                    </b-card>
                </div>
                <h5 class="mt-3 mb-2 text-capitalize">
                    <i class="fa fa-list-alt fa-lg mr-3" aria-hidden="true"></i>
                    <strong>Events of month</strong>
                </h5>
                <hr>
                <div v-if="itemHoliday.length != 0">
                    <b-list-group class="mb-5">
                        <b-list-group-item 
                            v-for="(item, indexDetail) in itemHoliday" :key="'eventL'+ indexDetail" 
                            class="flex-column align-items-start"
                        >
                            <div class="d-flex w-100 justify-content-between">
                                <div class="text-left">
                                    <div>
                                        <p class="mb-1 font-th">{{ item.Description }}</p>
                                    </div>
                                    <span 
                                        :class="{ 
                                            'bg-danger text-white font-sm-en-td' : item.calendar_type === 'holiday',
                                            'bg-info text-white font-sm-en-td' : item.calendar_type === 'payday',
                                            'bg-warning text-dark font-sm-en-td' : item.calendar_type === 'announce',
                                            'bg-pur text-dark font-sm-en-td' : item.calendar_type === 'event',
                                        }"
                                        class="font-th"
                                    >
                                        <i
                                            :class="{ 
                                                'fa fa-usd' : item.calendar_type === 'payday',
                                                'fa fa-bullhorn' : item.calendar_type === 'announce',
                                                'fa fa-bell' : item.calendar_type === 'event'
                                            }"
                                        >
                                        </i>
                                        {{ item.calendar_type }}
                                    </span>
                                    <span v-if="item.calendar_type === 'payday'">
                                        <br>
                                        <u>
                                            <b-link
                                                href="https://e-payroll.mahidol.ac.th/epayroll/" 
                                                target="_blang"  
                                                class="ml-2 text-info font-en"
                                            >e-payroll.mahidol.ac.th<i class="fa fa-external-link" aria-hidden="true"></i></b-link>
                                        </u>
                                        <br>
                                    </span>
                                    <p class="mt-3 mb-2"></p>
                                    <a 
                                        target="_blank"
                                        :href="'http://www.google.com/calendar/render?action=TEMPLATE&trp=false&text='+formatString(item.Description)+'&dates='+formatDate(item.addCalenDate)+'/'+formatDate(item.addCalenDate)"
                                    >
                                        <span class="font-weight-bold mt-2"><img src="@/assets/img/calendar-icon-add.png" class="d-inline-block align-middle mr-2" alt="">Add Google calendar</span>
                                    </a>
                                </div>
                                <div class="text-center">
                                    <h4 class="mt-1 mb-0 font-weight-bold font-en">
                                        {{ moment(item.Date).format('DD') }}
                                    </h4>
                                    <small class="text-muted mt-0 mb-0 font-en">{{ moment(item.Date).format('MMM YYYY') }}</small>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div v-else>
                    <h6 class="text-capitalize font-en text-muted">Still can't find any holidays or announcements</h6>
                </div>
                <h5 class="mt-3 mb-2 text-capitalize">
                    <i class="fa fa-user-times fa-lg mr-3" aria-hidden="true"></i>
                    <strong>Leave of absence</strong>
                </h5>
                <hr>
                <div v-if="itemAbsent.length != 0">
                    <b-list-group-item 
                        v-for="(itemAb, indexAbDetail) in itemAbsent" :key="'Absent'+ indexAbDetail" 
                        class="flex-column align-items-start"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <div class="text-left">
                                <h5 class="mb-1 font-th text-capitalize">{{ itemAb.Data.type }}</h5>
                                <p class="text-danger mt-0 mb-0 font-en">
                                    <i class="fa fa-calendar-times-o mr-1" aria-hidden="true"></i>{{ moment(itemAb.dates.start).format('ll') }} - {{ moment(itemAb.dates.end).format('ll') }}
                                </p>
                                <hr class="mt-1 mb-1">
                                <small class="text-muted mt-0 mb-0 font-en text-capitalize">Status : {{ itemAb.Data.status }}</small>
                            </div>
                            <div class="text-center">
                                <h3 class="mt-2 mb-0 font-weight-bold font-en">
                                    {{ itemAb.Data.amount }}
                                </h3>
                                <small class="text-muted mt-0 mb-0 font-en">Days.</small>
                            </div>
                        </div>
                    </b-list-group-item>
                </div>
                <div v-else>
                    <h6 class="text-capitalize font-en text-muted">Still can't find your vacation information this month.</h6>
                </div>
            </div>
        </div>
        <!-- modal ot or leave -->
        <b-modal ref="bv-modal-choice-calendar" id="bv-modal-choice-calendar" class="top-20" hide-footer>
            <template #modal-title>
                <strong class="font-en">Day selected</strong>
            </template>
            <div class="d-block">
                <b-media>
                    <template #aside>
                        <i class="fa fa-calendar fa-3x mr-3 text-muted" aria-hidden="true"/>
                    </template>
                    <h4 class="text-success text-capitalize font-en font-weight-bold mt-0 mb-1">{{ moment(selectDay).format('LL') }}</h4>
                    <h6 class="mt-1 text-capitalize font-en text-muted">What do you want to do on a date ?</h6>
                    <h6 class="mt-3 text-capitalize font-en">Leave of Absent</h6>
                    <b-button block variant="danger"><strong class="font-en text-wh" >Create leave form</strong></b-button>
                    <h6 class="mt-3 text-capitalize font-en">Overtime</h6>
                    <b-button block class="mb-2" variant="info"><strong class="font-en text-wh" >Create an overtime form</strong></b-button>
                </b-media>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import store from "@/store/index";
    export default {
        data(){
            return {
                fields: ['Date', 'Description','Remak'],
                itemHoliday:[],
                itemAbsent:[],
                attributes: [],
                a_Holiday:null,
                b_Holiday:null,
                attributesLeave:[],
                DayInfomation:this.moment().format(),
                itemInday:[],
                selectedDay:null,
                selectedDate:null,
                permitClick: !this.$store.state.permit.RulesUser.roles.includes('staff'),
                activeId:null,
                // modal form
                selectDay:null
            }
        },
        mounted(){
            this.dataInDay(this.moment().format('YYYY-MM-DD'),'auto')
        },
        computed: {
            layout() {
                return this.$screens(
                    {
                        // Default layout for mobile
                        default: {
                            columns: 1,
                            rows: 1,
                            isExpanded: true,
                        },
                        // Override for large screens
                        lg: {
                            columns: 2,
                            rows: 2,
                            isExpanded: false,
                        },
                    },
                );
            }
        },
        methods:{
            formatString (string) {
                return encodeURIComponent(string).replace(/%20/g, '+');
            },
            formatDate (date) {
                return date ? date.toISOString().replace(/-|:|\.\d+/g, '') : null;
            },
            // dayClicked (day) {
            //     console.log(day)
            //     console.log(day.attributes)
            //     console.log(day.attributesMap)
            //     this.selectedDay = day
            // },
            // inputValue (obj) {
            //     console.log(obj)
            // },
            timeCheckshow(arrAll , timeChk){
                if(arrAll.length != 0){
                    var arrStart = arrAll[arrAll.length - 1].c1
                    var a = this.moment(arrStart, 'hh:mm').add(15, 'minutes').valueOf()
                    var c = this.moment(timeChk, 'hh:mm').valueOf()
                    if(c >= a){
                        return true
                    }else{
                        return false
                    }
                }
            },
            async pageChange(obj) {
                this.getListHoliday(obj.month,obj.year)
            },
            getDayInFirst(month,year){
                return new Date(year, month, 1).getDate().toString().length == 1 ? '0'+new Date(year, month, 1).getDate() : new Date(year, month, 1).getDate();
            },
            getDayInLast(month,year){
                return new Date(year, month, 0).getDate().toString().length == 1 ? '0'+new Date(year, month, 0).getDate() : new Date(year, month, 0).getDate();
                // return new Date(year, month, 0).getDate();
            },
            async getListHoliday(dMont,dYear){
                const formatMount = dMont.toString().length == 1 ? '0'+dMont.toString() : dMont.toString()
                // console.log(formatMount)
                let startMonth = dYear+'-'+formatMount+'-'+this.getDayInFirst(dMont,dYear);
                let endMonth = dYear+'-'+formatMount+'-'+this.getDayInLast(dMont,dYear);
                // console.log('startMonth : ' + startMonth)
                // console.log('endMonth : ' + endMonth)
                try {
                    // holiday
                    const res_2 = await this.$http.get(`/hri/calendar_data/?timestart=${this.moment(startMonth).format('YYYY-MM-DD')}&timeend=${this.moment(endMonth).format('YYYY-MM-DD')}`)
                    // console.log(res_2.data)
                    if(res_2.status === 200){
                        this.attributes = []
                        // set holiday calendar
                        this.attributes = res_2.data.map(item => {
                            return {
                                key: item.id,
                                customData: {
                                    title: item.detail,
                                    class: '',
                                },
                                dates: {
                                    start : item.extra_date,
                                    end : item.extra_date,
                                },
                                calendar_type: item.calendar_type,
                            }
                        })
                        this.itemHoliday = []
                        // set holiday detail
                        this.itemHoliday = res_2.data.map(item => {
                            return {
                                key: item.id,
                                Description: item.detail,
                                Date: this.moment(item.extra_date).format('ll'),
                                addCalenDate: new Date(item.extra_date),
                                calendar_type: item.calendar_type,
                            }
                        })
                    }
                    // leave of absent
                    const res = await this.$http.get(`/hri/leave_of_absence/?timestart=${this.moment(startMonth).format('YYYY-MM-DD')}&timeend=${this.moment(endMonth).format('YYYY-MM-DD')}`)
                    // console.log(res.data)
                    if(res.status === 200){
                        this.attributesLeave = []
                        // set leave list calendar
                        this.attributesLeave = res.data.map(item => {
                            return {
                                'key': 1,
                                'customData': {
                                    'type': item.absence_type,
                                    'amount': `${item.absence_amount} Days.`,
                                    'class': 'bg-orange text-white width-set font-sm-en-td text-truncate',
                                    'status': item.status
                                },
                                'dates': {
                                    'start' : this.moment(item.start_date).format('YYYY-MM-DD'),
                                    'end' : this.moment(item.end_date).format('YYYY-MM-DD'),
                                }
                            }
                        })
                        this.itemAbsent = []
                        // set absent detail
                        this.itemAbsent = res.data.map(item => {
                            return {
                                'Data': {
                                    'type': item.absence_type,
                                    'amount': `${item.absence_amount}`,
                                    'class': 'bg-orange text-white width-set font-sm-en-td text-truncate',
                                    'status': item.status
                                },
                                'dates': {
                                    'start' : this.moment(item.start_date).format('YYYY-MM-DD'),
                                    'end' : this.moment(item.end_date).format('YYYY-MM-DD'),
                                }
                            }
                        })
                    }
                } catch (error) {}
            },
            showModal(daySelect) {
                this.selectDay = daySelect
                this.$refs['bv-modal-choice-calendar'].show()
            },
            async dataInDay(val,actionMouse){
                // if(actionMouse === 'cilckInday'){
                //     this.showModal(val)
                // }
                this.activeId = this.activeId === val ? null : val
                this.DayInfomation = val
                var start = `${this.moment(val).format('YYYY-MM-DD')}T00:00:00+07:00`
                var End = `${this.moment(val).format('YYYY-MM-DD')}T23:59:59+07:00`
                try {
                    // const res = await this.$http.get(`/hri/time_attendance/?created_at__gte=${encodeURIComponent(this.moment(val).format())}&created_at__lte=${encodeURIComponent(this.moment(val).add(1, 'days').format())}`)
                    const res = await this.$http.get(`/hri/time_attendance/?created_at__gte=${encodeURIComponent(start)}&created_at__lte=${encodeURIComponent(End)}`)
                    // console.log(res) itemInday
                    if(res.status === 200){
                        this.itemInday = []
                        this.itemInday = res.data.map(item => {
                            return {
                                'id': item.id,
                                'location': item.location,
                                'c': this.moment(item.created_at).format('MMMM Do YYYY'),
                                'c1': this.moment(item.created_at).locale('th').format('LTS'),
                                'c2': item.remark,
                            }
                        })
                    }
                } catch (error) {}
            }
        }
    }
</script>

<style>
    .vc-title{
        --text-lg : 2rem;
        --set : 12px 0px;
        font-size: var(--text-lg);
        cursor: pointer;
        -webkit-user-select: none;
        user-select: none;
        white-space: nowrap;
        padding: var(--set);
        line-height: 51px;
    }
    .vc-title-layout{ 
        font-family: 'Kanit', sans-serif;
        font-weight: 100;
    }
</style>

<style lang='css'>
    .top-20{ margin-top: 50px; }
    .text-wh{ color: #ffffff; }
    .weekday-1{
        background-color: #fff9e1;
    }
    .weekday-7 {
        background-color: #fff9e1;
    }
    .vc-weekday {
        font-family: 'Kanit', sans-serif;
        background-color: #000;
    }
    .card-CALEN:hover { 
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2); 
        background-color: #a2c5f5;
    }
</style>

<style lang="postcss" scoped>
    .font-th{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Baloo Tamma 2', cursive; }
    .font-sm{ 
        font-size: 0.85rem; 
        font-family: 'Kanit', sans-serif; font-weight: 100;
        padding-right: 10px;
        padding-left: 10px;
    }
    .font-sm-en{ 
        font-size: 0.85rem; 
        font-family: 'Baloo Tamma 2', cursive;
        padding-right: 10px;
        padding-left: 10px;
    }
    .font-sm-en-td{ 
        font-size: 0.85rem; 
        font-family: 'Baloo Tamma 2', cursive;
        padding-right: 7px;
        padding-left: 7px;
        border-radius: 5px;
    }
    .height-set{
        height: 125px;
        overflow: auto;
    }
    .bg-info-custom{ background-color: #fff; }
    .bg-actt{ background-color: #e5eefb; }
    .bg-pur { background-color: #ccbeff; }
    .bg-orange { background-color: #ffb24c; }
    ::-webkit-scrollbar {
        width: 0px;
    }
    ::-webkit-scrollbar-track {
        display: none;
    }
    
    /deep/ .custom-calendar.vc-container {
        --day-border: 1px solid #b8c2cc;
        --day-border-highlight: 1px solid #b8c2cc;
        --day-width: 90px;
        --day-height: 90px;
        --weekday-bg: #f8fafc;
        --weekday-border: 1px solid #eaeaea;
        border-radius: 0;
        width: 100%;
        & .vc-header {
            font-size: 1.95rem;
            background-color: #f1f5f8;
            padding: 10px 0;
        }
        & .vc-weeks {
            padding: 0;
        }
        & .vc-weekday {
            background-color: var(--weekday-bg);
            border-bottom: var(--weekday-border);
            border-top: var(--weekday-border);
            padding: 5px 0;
            background-color: #000;
        }
        & .vc-day {
            padding: 0 5px 3px 5px;
            text-align: left;
            height: var(--day-height);
            min-width: var(--day-width);
            background-color: #000;
            &.weekday-1,
            &.weekday-7 {
                background-color: #eff8ff;
            }
            &:not(.on-bottom) {
                border-bottom: var(--day-border);
            &.weekday-1 {
                border-bottom: var(--day-border-highlight);
            }
            }
            &:not(.on-right) {
                border-right: var(--day-border);
            }
        }
        & .vc-day-dots {
            margin-bottom: 5px;
        }
    }
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .width-set{
            width: 40px;
        }
        .height-set{
            height: 85px;
            overflow: auto;
        }
    }
    @media only screen and (min-width: 600px){
        .width-set{
            width: 50px;
        }
    }
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .width-set{
            width: 150px;
        }
    }
    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .width-set{
            width: 84px;
        }
    }
    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 1300px) and (max-width:1500px) {
        .width-set{
            width: 100px;
        }
    } 
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1501px) {
        .width-set{
            width: 156px;
        }
    }
</style>